import { request } from "./http";

export const adminService = {
  getCompanies() {
    return request("/Admin/companies");
  },

  getStatistics() {
    return request("/Admin/statistics");
  },

  updatePaymentStatus(companyId, hasPaid) {
    return request(`/Admin/companies/${companyId}/payment-status`, {
      method: "PUT",
      body: {
        companyId,       
        hasPaid: !!hasPaid,
      },
    });
  },
};
